/**
 * Billing-month arithmetic for the Channex cost screen.
 *
 * All three are about the one thing a date function gets wrong — boundaries.
 * The backend keys usage rows by the first of the month in UTC, so a viewer
 * west of Greenwich must not be able to ask for a month the server never wrote.
 */

/** `YYYY-MM` for the month `date` falls in, UTC — matches the backend's period key. */
export function periodOf(date: Date): string {
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
}

/** The period `months` away from `period`, rolling the year over as needed. */
export function shiftPeriod(period: string, months: number): string {
  const [year, month] = period.split('-').map(Number);
  return periodOf(new Date(Date.UTC(year ?? 1970, (month ?? 1) - 1 + months, 1)));
}

/**
 * Whole CALENDAR days from today until `isoDate`, or null when there is no
 * usable date. Midnight to midnight, not elapsed hours rounded off: a property
 * due for deletion on the 27th must read the same all day. Negative for a date
 * already past — "deleted three days ago" and "deleted today" differ.
 */
export function daysUntil(isoDate: string | null, now: Date = new Date()): number | null {
  if (!isoDate) return null;
  const target = new Date(`${isoDate}T00:00:00.000Z`).getTime();
  if (Number.isNaN(target)) return null;
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return Math.round((target - today) / 86_400_000);
}
